import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmedValidator } from '../../confirmed.validator';
import { UtilitaService } from '../../services/utilita.service';


@Component({
  selector: 'app-mostra-nominativi',
  templateUrl: './mostra-nominativi.component.html',
  styleUrls: ['./mostra-nominativi.component.css'],
})
export class MostraNominativiComponent implements OnInit {
  lstElencoPerUpdateFilter: any;
  lstElenco: any;
  txtFiltra: any;
  numerorighe: number = 8;


  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<MostraNominativiComponent>,
    private snackBar: MatSnackBar,
    private srvUtilita: UtilitaService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }


  ngOnInit(): void {
    if (this.data.idDipartimento) { console.log('idutente', this.data.idDipartimento)  }
    if (this.data.idutente) { console.log('idutente', this.data.idutente) }
    if (this.data.idRichiesta) { console.log('idrichiesta', this.data.idRichiesta) }

    this.getUtentiDipartimento(this.data.idDipartimento, '', '')
  }

  getUtentiDipartimento(idDipartimento: number, sNome: string, sCognome: string) {
    this.srvUtilita.getLista('Utenti/GetUtentiProfiloLista?iIdDipartimentoUtenteLoggato=' + idDipartimento
      + '&sNome=' + sNome + '&sCognome=' + sCognome).subscribe((res: any) => {
        this.lstElenco = res;
        this.lstElencoPerUpdateFilter = res;
        console.log("lstElenco: ", res);
      }, (err: any) => {
      })
  }

  showMessage(message: string, action: string) {
    this.snackBar.open(message, action, { duration: 3000 })
  }
  btnSalva(iIdUtente:number) {
    const obj =
    {
      idUtenteProfilo: iIdUtente,
      idRichiestaProfilo: this.data.idRichiesta
    }
    this.srvUtilita.postObj('Clienti/AssociaNominativoAllaRichiesta', obj).subscribe((res: any) => {
      this.showMessage('Operazione avvenuta correttamente.', 'OK')
     // this.dialogRef.close()


    }, (err: any) => {
      this.showMessage('Errore: i dati non sono stati inseriti in modo corretto.', 'OK')
      // console.log(err.error.Message, 'ERRORE');
    })

  }

  btnEsci() {
    this.dialogRef.close();
  }

  updateFilter(event: any) {
    const val = event.target.value.toLowerCase()
    const columns = Object.keys(this.lstElencoPerUpdateFilter[0])
    columns.splice(columns.length - 1)
    if (!columns.length) {
      return
    }
    this.lstElenco = this.lstElencoPerUpdateFilter;
    const rows = this.lstElenco.filter(function (d: any) {
      for (let i = 0; i <= columns.length; i++) {
        const column = columns[i]
        if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
          return true
        }
      }
    })
    this.lstElenco = rows
  }

 

}
